import _ from 'lodash';

const redColor = '#fe0c04';
const greenColor = '#0bb050';
const whiteColor = '#ffffff';

export const formatPrice = (price) => {
  return (price).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
const countUnixValue = (data, field) => {
  const results = _
    .chain(data)
    .map((item) => _.get(item, field))
    .uniq()
    .size()
    .value();
  return results;
}

const newFormatProject = (data, field, minColor, maxColor, countUnix) => {
  const results = _.map(data, (o, i) => {
    const customData = (_.get(o, field) === 'n/a' || _.get(o, field) === 'N/A') ? 0 : _.get(o, field);
    const myValue = field === 'distanceFromBts' ? _.get(o, field) : customData;
    return {
      index: i,
      id: o.id,
      value: myValue,
      field: field,
      minColor: countUnix <= 1 ? whiteColor : minColor,
      maxColor: countUnix <= 1 ? whiteColor : maxColor
    }
  });
  return results;
}

const mapResult = (data, minData, maxData, countUnix) => {
  if (countUnix >= 1) {
    const min = _.minBy(data, 'value');
    const minFilter = _.filter(data, (o) => { return o.value === _.get(min, 'value'); });
    const max = _.maxBy(data, 'value');
    const maxFilter = _.filter(data, (o) => { return o.value === _.get(max, 'value'); });
    minData = _.concat(minData, minFilter);
    maxData = _.concat(maxData, maxFilter);
  }
  return { minData, maxData }
}

const fillForHilight = [
  { fill: 'distanceFromBts', minClolr: greenColor, maxColor: redColor },
  { fill: 'totalUnits', minClolr: greenColor, maxColor: redColor },
  { fill: 'parkingLot', minClolr: redColor, maxColor: greenColor },
  { fill: 'resalePriceSqm', minClolr: greenColor, maxColor: redColor },
  { fill: 'percentSold', minClolr: redColor, maxColor: greenColor },
  { fill: 'unitsLeft', minClolr: greenColor, maxColor: redColor },
  { fill: 'ceiling', minClolr: greenColor, maxColor: redColor },
  { fill: 'sinkingFund', minClolr: redColor, maxColor: greenColor },
  { fill: 'commonFee', minClolr: redColor, maxColor: greenColor },
]
export const setFormatForFillBgColor = (projects) => {
  const projectArr = _.toArray(projects);
  let minAll = [];
  let maxAll = [];

  _.map(fillForHilight, (fillObj) => {
    const distanctValueArr = countUnixValue(projectArr, _.get(fillObj, 'fill'));
    const distanctFormBts = newFormatProject(projectArr, _.get(fillObj, 'fill'), _.get(fillObj, 'minClolr'), _.get(fillObj, 'maxColor'), distanctValueArr);
    let finalData;
    if (_.get(fillObj, 'fill') !== 'distanceFromBts') {
      finalData = _.filter(distanctFormBts, (item) => item.value !== 0);
    } else {
      finalData = distanctFormBts;
    }
    const resDistanct = mapResult(finalData, minAll, maxAll, distanctValueArr);
    minAll = _.get(resDistanct, 'minData');
    maxAll = _.get(resDistanct, 'maxData');
  })

  // /* ********* Distanct Form Bts Mrt ******** */
  // const distanctValueArr = countUnixValue(projectArr, 'distanceFromBts');
  // const distanctFormBts = newFormatProject(projectArr, 'distanceFromBts', greenColor, redColor, distanctValueArr);
  // const resDistanct = mapResult(distanctFormBts, minAll, maxAll, distanctValueArr);
  // minAll = resDistanct.minData;
  // maxAll = resDistanct.maxData;

  // /* ********* Total Units ******** */
  // const totalUnitValueArr = countUnixValue(projectArr, 'totalUnits');
  // const totalUnitFormat = newFormatProject(projectArr, 'totalUnits', greenColor, redColor, totalUnitValueArr);
  // const restoTalUnits = mapResult(totalUnitFormat, minAll, maxAll, totalUnitValueArr);
  // minAll = restoTalUnits.minData;
  // maxAll = restoTalUnits.maxData;

  // /* ********* Parking Lot ******** */
  // const parkingLotValueArr = countUnixValue(projectArr, 'parkingLot');
  // const parkingLotFormat = newFormatProject(projectArr, 'parkingLot', redColor, greenColor, parkingLotValueArr);
  // const resParkingLot = mapResult(parkingLotFormat, minAll, maxAll, parkingLotValueArr);
  // minAll = resParkingLot.minData;
  // maxAll = resParkingLot.maxData;

  // // /* ********* Year Launch ******** */
  // // const yearLaunchValueArr = countUnixValue(projectArr, 'yearLaunch');
  // // const yearLaunchFormat = newFormatProject(projectArr, 'yearLaunch', greenColor, redColor, yearLaunchValueArr);
  // // const resYearLaunchFormat = mapResult(yearLaunchFormat, minAll, maxAll, yearLaunchValueArr);
  // // minAll = resYearLaunchFormat.minData;
  // // maxAll = resYearLaunchFormat.maxData;

  // // /* ********* CompleteYear ******** */
  // // const completeYearValueArr = countUnixValue(projectArr, 'yearComplete');
  // // const completeYearFormat = newFormatProject(projectArr, 'yearComplete', greenColor, redColor, completeYearValueArr);
  // // const resCompleteYear = mapResult(completeYearFormat, minAll, maxAll, completeYearValueArr);
  // // minAll = resCompleteYear.minData;
  // // maxAll = resCompleteYear.maxData;

  // /* ********* Resale Price Sqm ******** */
  // const resalePriceValueArr = countUnixValue(projectArr, 'resalePriceSqm');
  // const resalePriceFormat = newFormatProject(projectArr, 'resalePriceSqm', greenColor, redColor, resalePriceValueArr);
  // const resResalePrice = mapResult(resalePriceFormat, minAll, maxAll, resalePriceValueArr);
  // minAll = resResalePrice.minData;
  // maxAll = resResalePrice.maxData;

  // /* ********* Percent Sold ******** */
  // const percentSoldValueArr = countUnixValue(projectArr, 'percentSold');
  // const percentSoldFormat = newFormatProject(projectArr, 'percentSold', redColor, greenColor, percentSoldValueArr);
  // const resPercentSold = mapResult(percentSoldFormat, minAll, maxAll, percentSoldValueArr);
  // minAll = resPercentSold.minData;
  // maxAll = resPercentSold.maxData;

  // /* ********* Units Left ******** */
  // const unitsLeftValueArr = countUnixValue(projectArr, 'unitsLeft');
  // const unitsLeftFormat = newFormatProject(projectArr, 'unitsLeft', greenColor, redColor, unitsLeftValueArr);
  // const resUnitsLeft = mapResult(unitsLeftFormat, minAll, maxAll, unitsLeftValueArr);
  // minAll = resUnitsLeft.minData;
  // maxAll = resUnitsLeft.maxData;

  // /* ********* Ceiling ******** */
  // const percentCeiling = countUnixValue(projectArr, 'ceiling');
  // const ceilingFormat = newFormatProject(projectArr, 'ceiling', greenColor, redColor, percentCeiling);
  // const resCeiling = mapResult(ceilingFormat, minAll, maxAll, percentCeiling);
  // minAll = resCeiling.minData;
  // maxAll = resCeiling.maxData;

  // /* ********* Sinking Fund ******** */
  // const sinkingFundValueArr = countUnixValue(projectArr, 'sinkingFund');
  // const sinkingFundFormat = newFormatProject(projectArr, 'sinkingFund', redColor, greenColor, sinkingFundValueArr);
  // const resSinkingFund = mapResult(sinkingFundFormat, minAll, maxAll, sinkingFundValueArr);
  // minAll = resSinkingFund.minData;
  // maxAll = resSinkingFund.maxData;

  // /* ********* Common Fee ******** */
  // const commonFeeValueArr = countUnixValue(projectArr, 'commonFee');
  // const commonFeeFormat = newFormatProject(projectArr, 'commonFee', redColor, greenColor, commonFeeValueArr);
  // const resCommonFee = mapResult(commonFeeFormat, minAll, maxAll, commonFeeValueArr);
  // minAll = resCommonFee.minData;
  // maxAll = resCommonFee.maxData;

  return {
    min: minAll,
    max: maxAll
  }
}

export const calColor = (field = '', minArr, maxArr, indexRow = '', amountArr) => {
  // Check Case 1 Result
  if (amountArr <= 1) {
    return 'white';
  }

  // Check Case Min
  const isMin = _.find(minArr, (o, i) => {
    if (o.id === indexRow && o.field === field) {
      return o.minColor;
    }
  });
  if (!_.isUndefined(isMin)) {
    return isMin.minColor;
  }

  // Check Case Max
  const isMax = _.find(maxArr, (o, i) => {
    if (o.id === indexRow && o.field === field) {
      return o.maxColor;
    }
  });
  if (!_.isUndefined(isMax)) {
    return isMax.maxColor;
  }

  // Default Case
  return 'white';
}


// WEBPACK FOOTER //
// ./src/screens/CompareProject/functions.js